import ConversaoService from "@/services/ConversaoService";

export const conversao = {
  namespaced: true,
  state: {
    conversao: {},
  },
  actions: {
    converterPlanilha({ commit }, payload) {
      return ConversaoService.ConverterPlanilha(payload).then(
        (conversao) => {
          return Promise.resolve(conversao);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default conversao;
